/**
 * Both rules hold on purpose, so one step can show two hours depending on the screen: 09:00 for the admin,
 * the evening before for a participant on the other side of the world. Not a bug.
 */
export enum TimezoneDisplayModeEnum {
  /** The step's hours as entered, with its zone label: admin screens. */
  STEP = "step",
  /** Hours converted into the reader's zone, without a label: participant screens. */
  READER = "reader",
}
